(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["ImageUploader"] = factory(require("axios"));
	else
		root["ImageUploader"] = factory(root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/writer-util/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var ajax = axios_1.default.create({
    headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json; charset=UTF-8'
    },
    timeout: 0
});
var ImageUploader = function () {
    function ImageUploader(dataArray, options) {
        this.num = 0;
        this.dataArray = dataArray || [];
        this.options = __assign({
            'size': 5 * 1024 * 1024,
            'x:protocol': 'http'
        }, options);
    }
    ImageUploader.prototype.getError = function (code) {
        var errors = {
            1: 'url为空或file不存在',
            2: '不支持该协议',
            3: '图片格式错误，请使用jpg/jpeg/png/gif文件',
            4: "\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7\u9650\u5236\uFF0C\u8BF7\u9009\u62E9" + (this.options.size / 1024 / 1024).toFixed(2) + "MB\u4EE5\u4E0B\u7684\u6587\u4EF6",
            5: '网络异常'
        };
        return {
            code: code,
            message: errors[code]
        };
    };
    ImageUploader.prototype.checkError = function (data) {
        var url = data.url,
            file = data.file;
        if ('file' in data && file) {
            if (common_1.isIFile(file)) {
                var size = file.size,
                    type = file.type;
                if (type === undefined || type === '' || !common_1.isValidType(type)) {
                    return this.getError(3);
                }
                if (size && size > this.options.size) {
                    return this.getError(4);
                }
            } else {
                return this.getError(1);
            }
        }
        if ('url' in data && url) {
            if (url === undefined || url === '') {
                return this.getError(1);
            }
            if (!common_1.isValidProtocol(url)) {
                return this.getError(2);
            }
        }
        return false;
    };
    ImageUploader.prototype.isCompleted = function () {
        var len = this.dataArray.length;
        return this.num === len;
    };
    ImageUploader.prototype.upload = function (uploaderData) {
        var _this = this;
        var url = uploaderData.url,
            file = uploaderData.file;
        var error = this.checkError(uploaderData);
        if (error) {
            return new Promise(function (resolve, reject) {
                _this.num++;
                reject(error);
            });
        }

        if (common_1.isIFile(file)) {
            return new Promise(function (resolve, reject) {
                ajax.get('/upload_images/token.json', {
                    params: {
                        filename: file.name || 'image.png'
                    }
                }).then(function (res1) {
                    var tokenData = res1.data;
                    var token = tokenData.token,
                        key = tokenData.key;
                    var formData = new FormData();
                    formData.append('token', token);
                    formData.append('key', key);
                    formData.append('file', file);
                    formData.append('x:protocol', _this.options['x:protocol']);

                    ajax.post('https://upload.qiniup.com', formData).then(function (res2) {
                        var data = res2.data;
                        var result = __assign({}, data, { url: common_1.getImageUrl(data.url, data.format) });
                        _this.num++;
                        resolve(result);
                    }).catch(function () {
                        _this.num++;
                        reject(_this.getError(5));
                    });
                }).catch(function () {
                    _this.num++;
                    reject(_this.getError(5));
                });
            });
        }

        if (url !== undefined && url !== '') {
            return new Promise(function (resolve, reject) {
                var meta = document.querySelector('meta[name="csrf-token"]');
                var token = meta && meta.content ? meta.content : '';

                ajax.post('/upload_images/fetch', { url: decodeURIComponent(url) }, { headers: { 'X-CSRF-Token': token } }).then(function (res) {
                    var data = res.data;
                    var result = __assign({}, data, { url: common_1.getImageUrl(data.url, data.format) });
                    _this.num++;
                    resolve(result);
                }).catch(function () {
                    _this.num++;
                    reject(_this.getError(5));
                });
            });
        }
        return new Promise(function (resolve, reject) {
            _this.num++;
            reject(_this.getError(1));
        });
    };
    return ImageUploader;
}();
module.exports = ImageUploader;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

exports.ImageTypeReg = /(.|\/)(jpe?g|png|gif)$/i;
exports.ProtocolReg = /^(https?:)?\/\//;
function isBlob(blob) {
    return Object.prototype.toString.call(blob) === '[object Blob]';
}
exports.isBlob = isBlob;
function isFile(file) {
    return Object.prototype.toString.call(file) === '[object File]';
}
exports.isFile = isFile;
function isIFile(file) {
    return isFile(file) || isBlob(file);
}
exports.isIFile = isIFile;
function isValidType(type) {
    return type && exports.ImageTypeReg.test(type);
}
exports.isValidType = isValidType;
function isValidProtocol(url) {
    return url && exports.ProtocolReg.test(url);
}
exports.isValidProtocol = isValidProtocol;
function getImageUrl(url, format) {
    var result = url + "?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240";
    if (format === 'webp') {
        result = url + "?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240/format/jpg";
    } else if (format === 'gif') {
        result = url + "?imageMogr2/auto-orient/strip";
        // result = url;
    }
    return result;
}
exports.getImageUrl = getImageUrl;

/***/ })
/******/ ]);
});
//# sourceMappingURL=ImageUploader.js.map



// WEBPACK FOOTER //
// ./src/assets/vendors/ImageUploader.js